import { ENVIRONMENT } from './env.js';

const SPLIT_MAIN = "0x2ed6c4B5dA6378c7897AC67Ba9e43102Feb694EE";
const MULTICALL3 = "0xcA11bde05977b3631167028862bE2a173976CA11";
const THIRD_PARTY_CONTRACTS = {
  splitMain: SPLIT_MAIN,
  multicall3: MULTICALL3
};
const GOERLI_LEGACY_ARTIST_CONTRACTS = {
  artistCreator: ENVIRONMENT === "staging" ? "0x7E24FD79640d0e6AAc0d7E56b2B0c5689B1C58b6" : "0xA4f5f9A509C28A09D661115C4cD6320a08a8e0c6"
};
const MAINNET_LEGACY_ARTIST_CONTRACTS = {
  artistCreator: "0x78E3aDc0E811e4f93BD9F1f9389b923c9A3355c2"
};
const ETH_SOUND_LEGACY_ARTIST_CONTRACTS = ENVIRONMENT === "production" ? MAINNET_LEGACY_ARTIST_CONTRACTS : GOERLI_LEGACY_ARTIST_CONTRACTS;
const TEMPORARY_NOT_DEPLOYED_ADDRESS = "0xNOT_DEPLOYED_YET";
const GOERLI_SOUND_CONTRACTS = {
  goldenEggMetadata: "0x968ca7592c59621f99f1054c7bdc5706cece902a",
  soundCreatorV1: ENVIRONMENT === "staging" ? "0x97eC2AB8Fbe64E95597250627A95Aa1E2caA4019" : "0xa63f337C0f8bCa8960B6185887aF17915398daB8",
  soundCreatorV2: "0x0000000000aec84F5BFc2af15EAfb943bf4e3522",
  soundCreatorV1Tiers: TEMPORARY_NOT_DEPLOYED_ADDRESS,
  soundEditionV1: "0xBC327C32bED01787257355eBba25a0De25c85019",
  openEditionGoldenEggMetadata: "0xb3D6EFD8a463193ae15676330CD5c39008115C7A",
  rangeEditionMinterV2_1: "0x4d25a8b0df55b4b2f2d2acfcec1c68a68b583fca",
  merkleDropMinterV2_1: "0x4f8e25732b6c3d13e2964c3e6dbc784bcc979a79",
  samV1_1: "0x9f0007097979f759363263103b115e22191dd1db",
  superMinterV1: "0x0000000000CF4558c36229ac0026ee16D3aE35Cd",
  soundMetadataAddress: "0x0000000000f5A96Dc85959cAeb0Cfe680f108FB5"
};
const GOERLI_MINTERS_V1_DEPRECATED = {
  fixedPriceSignatureMinter: "0xe8cf83355f3c5a45360ea84f23a8675281a31d0f",
  merkleDropMinter: "0x6cd6bc3cb59f21e957fd1f56003ba60d64930a80",
  rangeEditionMinter: "0x5fbf9fa5e9e7195d783c98f30c1171ef8e3c2c2b",
  mintAdapter: "0xea5b2b818ae906eca319f87a32cf327b01c75d14"
};
const GOERLI_MINTERS_V2_DEPRECATED = {
  merkleDropMinterV2: "0xa39510250ab64bca4e068aef4f2959bf864a2fa5",
  rangeEditionMinterV2: "0xddd1ef15c5c374565fd4f3dd736e30e2c37a5a5c"
};
const GOERLI_SAM_V1_DEPRECATED = ENVIRONMENT === "staging" ? "0x375D87D85718804F5B6f63427e82AAf4a851Ee24" : "0x7a0a8703bfc28ede950cf19e377e92d3ef122571";
const MAINNET_SOUND_CONTRACTS = {
  goldenEggMetadata: "0x3ca50e8da8c3d359fc934aea0161f5346ccb62a1",
  soundCreatorV1: "0xaef3e8c8723d9c31863be8de54df2668ef7c4b89",
  soundCreatorV2: "0x0000000000aec84F5BFc2af15EAfb943bf4e3522",
  soundCreatorV1Tiers: "0xaef3e8c8723d9c31863be8de54df2668ef7c4b89",
  soundEditionV1: "0x8cfbfae570d673864cd61e1e4543eb7874ca35c2",
  openEditionGoldenEggMetadata: "0xE311e941D49DBf1747E8531209f4d3F4c49F5eA0",
  merkleDropMinterV2_1: "0x64f877c44364f840e676fc19cf1711ef95b57bf5",
  rangeEditionMinterV2_1: "0x3c95775ba56bfcd337998cc84f0388251d6aec7b",
  samV1_1: "0x9fbd0eae64c6c5427914fc4939cd62a3fd88d217",
  superMinterV1: "0x0000000000CF4558c36229ac0026ee16D3aE35Cd",
  soundMetadataAddress: "0x0000000000f5A96Dc85959cAeb0Cfe680f108FB5"
};
const MAINNET_MINTERS_V1_DEPRECATED = {
  fixedPriceSignatureMinter: "0xc47306699611fc4c84744dcd7f458938b829506a",
  merkleDropMinter: "0xeae422887230c0ffb91fd8f708f5fdd354c92f2f",
  rangeEditionMinter: "0x65c25fadd9b88df5c8c101a3b99a5d614b708596",
  mintAdapter: "0x1d47be23fb5221fb8f5805184a61a38b3c0082ad"
};
const MAINNET_MINTERS_V2_DEPRECATED = {
  merkleDropMinterV2: "0xc025b29469b651a2c85bdda533664c92968533f3",
  rangeEditionMinterV2: "0x6c05ead00da635e7de355977428d1fb31f80fd54"
};
const MAINNET_SAM_V1_DEPRECATED = "0xb77a65e680ba99bdfb530d3cc0692cd75b088ba1";
const OPTIMISM_GOERLI_SOUND_CONTRACTS = {
  soundCreatorV1: ENVIRONMENT === "staging" ? "0x3BE1036c67B65BbC481f678a42c268177A3779D3" : "0x5bCF5773BCf1f131A0Cad5c74aa9Be1a80b63c55",
  soundCreatorV1Tiers: ENVIRONMENT === "staging" ? TEMPORARY_NOT_DEPLOYED_ADDRESS : "0x039a41ee6d2b77d0fd91ae44ba070855a6ebc755",
  soundCreatorV2: "0x0000000000aec84F5BFc2af15EAfb943bf4e3522",
  soundEditionV1: "0x00000000ee37E4f29070cab8C6a73Cb43f2dD73d",
  openEditionGoldenEggMetadata: "0x00000000C417a48cD096067520747607a0331F0e",
  merkleDropMinterV2_1: "0x4103f829df71a7b736b41951b1db726fe4161947",
  rangeEditionMinterV2_1: "0x47FD52c23AF086D11AEfE2E9A35D806454Aba760",
  goldenEggMetadata: "0x09Fc8d908f165A0734dddd3034a5a727486ABFEE",
  samV1_1: "0xcf381fd9a29cbefbc9f6d4fa9e38b130ea8a2d77",
  superMinterV1: "0x0000000000CF4558c36229ac0026ee16D3aE35Cd",
  soundMetadataAddress: "0x0000000000f5A96Dc85959cAeb0Cfe680f108FB5"
};
const OPTIMISM_GOERLI_MINTERS_V2_DEPRECATED = {
  merkleDropMinterV2: "0x9b679B55618366e3b26f6F6ec0eb2f98E8999304",
  rangeEditionMinterV2: "0x385E9F438A8B5CA54bc87E2b826fb7aDfDc3fD7f"
};
const OPTIMISM_GOERLI_SAM_V1_DEPRECATED = "0x44CFC4B6892cf2DFe028fe5ac1bd287B7393f06e";
const OPTIMISM_MAINNET_SOUND_CONTRACTS = {
  soundCreatorV1: "0x5bcf5773bcf1f131a0cad5c74aa9be1a80b63c55",
  soundCreatorV1Tiers: "0x5bcf5773bcf1f131a0cad5c74aa9be1a80b63c55",
  soundCreatorV2: "0x0000000000aec84F5BFc2af15EAfb943bf4e3522",
  soundEditionV1: "0x00000000ee37e4f29070cab8c6a73cb43f2dd73d",
  openEditionGoldenEggMetadata: "0x00000000c417a48cd096067520747607a0331f0e",
  merkleDropMinterV2_1: "0x46F81107e99aDf80B8EA49aB7281b984F826fbD0",
  rangeEditionMinterV2_1: "0x403471cbcab399896004bc0af2b4674d4ab3b53b",
  goldenEggMetadata: "0x385e9f438a8b5ca54bc87e2b826fb7adfdc3fd7f",
  samV1_1: "0x12a1458b9162dbf50983e72e78e41e37f5bf1a80",
  superMinterV1: "0x0000000000CF4558c36229ac0026ee16D3aE35Cd",
  soundMetadataAddress: "0x0000000000f5A96Dc85959cAeb0Cfe680f108FB5"
};
const OPTIMISM_MAINET_MINTERS_V2_DEPRECATED = {
  merkleDropMinterV2: "0x65d21a94c78a5f9ef68a2be141d0c91afc51a7d3",
  rangeEditionMinterV2: "0x1a36729fc276c3649da2cf1eb986d7dabd5d5d99"
};
const OPTIMISM_MAINNET_SAM_V1_DEPRECATED = "0x2a3a42c653e427f4d44ea47007a99ee6bbae65af";
function exhaustiveGuard(_value) {
  throw new Error(`Exhaustive guard reached with value ${_value}`);
}
function getContractsForChain(chain) {
  switch (chain) {
    case "GOERLI":
      return GOERLI_SOUND_CONTRACTS;
    case "MAINNET":
      return MAINNET_SOUND_CONTRACTS;
    case "OPTIMISM_GOERLI":
      return OPTIMISM_GOERLI_SOUND_CONTRACTS;
    case "OPTIMISM":
      return OPTIMISM_MAINNET_SOUND_CONTRACTS;
    default:
      exhaustiveGuard(chain);
  }
}
function getAllMinterContractsForChain(chain) {
  const currentMinters = getContractsForChain(chain);
  const deprecatedMinters = getDeprecateMintersForChain(chain);
  let allMinterEntries = [
    ...Object.entries(currentMinters),
    ...deprecatedMinters.v1 ? Object.entries(deprecatedMinters.v1) : [],
    ...Object.entries(deprecatedMinters.v2)
  ];
  let minterContractAddresses = allMinterEntries.reduce(
    (acc, [key, value]) => {
      if (key.toLowerCase().includes("minter")) {
        acc.push(value);
      }
      return acc;
    },
    []
  );
  minterContractAddresses.push(currentMinters.samV1_1, deprecatedMinters.sam);
  return minterContractAddresses.map(
    (address) => address.toLowerCase()
  );
}
function getDeprecateMintersForChain(chain) {
  switch (chain) {
    case "GOERLI":
      return {
        v1: GOERLI_MINTERS_V1_DEPRECATED,
        v2: GOERLI_MINTERS_V2_DEPRECATED,
        sam: GOERLI_SAM_V1_DEPRECATED
      };
    case "MAINNET":
      return {
        v1: MAINNET_MINTERS_V1_DEPRECATED,
        v2: MAINNET_MINTERS_V2_DEPRECATED,
        sam: MAINNET_SAM_V1_DEPRECATED
      };
    case "OPTIMISM_GOERLI":
      return {
        v1: null,
        v2: OPTIMISM_GOERLI_MINTERS_V2_DEPRECATED,
        sam: OPTIMISM_GOERLI_SAM_V1_DEPRECATED
      };
    case "OPTIMISM":
      return {
        v1: null,
        v2: OPTIMISM_MAINET_MINTERS_V2_DEPRECATED,
        sam: OPTIMISM_MAINNET_SAM_V1_DEPRECATED
      };
    default:
      exhaustiveGuard(chain);
  }
}
function soundCreatorDeployBlock(chainName) {
  let blockNumber;
  switch (chainName) {
    case "GOERLI":
      blockNumber = 8034505;
      break;
    case "MAINNET":
      blockNumber = 15570834;
      break;
    case "OPTIMISM_GOERLI":
      blockNumber = 9475362;
      break;
    case "OPTIMISM":
      blockNumber = 105010252;
      break;
    default:
      exhaustiveGuard(chainName);
  }
  return blockNumber;
}
const PROVIDER_RETRY_INTERVAL = 1e3;
const PROVIDER_RETRY_ATTEMPT_LIMIT = 3;

export { ETH_SOUND_LEGACY_ARTIST_CONTRACTS, GOERLI_LEGACY_ARTIST_CONTRACTS, MAINNET_LEGACY_ARTIST_CONTRACTS, PROVIDER_RETRY_ATTEMPT_LIMIT, PROVIDER_RETRY_INTERVAL, TEMPORARY_NOT_DEPLOYED_ADDRESS, THIRD_PARTY_CONTRACTS, getAllMinterContractsForChain, getContractsForChain, getDeprecateMintersForChain, soundCreatorDeployBlock };
